import { Stack } from '@mui/material';

import { OffersGridLocation } from '@ocx/graphql';
import { useRudderStack } from '@ocx/data-analytics';
import { useMembership } from '@ocx/data-membership';
import { LoyaltyIdBarcodeController } from '@ocx/feat-loyalty-id-barcode';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ReferralStatusController } from '@ocx/feat-referrals';
import { SizingMultiplier } from '@ocx/ui';
import { useConfigurationContext } from '@ocx/data-configuration';

import { HomeLayout } from './home.layout';
import { HomeRefreshProvider } from './context/home-refresh.context';
import { HomePageContent } from './components/home-page-content.component';
import { WelcomeSectionController } from './components/welcome-section.controller';
import { HowDoesItWorkCardController } from './components/how-does-it-work-card.controller';
import { RewardsController } from './components/rewards.controller';
import { HomeOffersFeaturedStripController } from './components/home-offers-featured-strip.controller';
import { HomeOffersGridOnHomeController } from './components/home-offers-grid-on-home.controller';
import { LoyaltyEventBackdropController } from './components/loyalty-event-backdrop.controller';
import { HomeBottomNavigationController } from './components/home-bottom-navigation.controller';
import { HomeRoutes } from './components/home-routes.component';
import { useHomeAppRateEffect } from './hooks/use-home-app-rate-effect.hook';
import { useHomeMembershipRefreshEffect } from './hooks/use-home-membership-refresh-effect.hook';
import { useHomePushNotificationsEffect } from './hooks/use-home-push-notifications-effect.hook';
import { useHomeSurveyEffect } from './hooks/use-home-survey-effect.hook';

export const HomeController = () => {
  const { triggerEvent } = useRudderStack();
  const { membership } = useMembership();
  const { refetch: refetchConfig, config } = useConfigurationContext();
  const { fetchAndOpenSurveyModal } = useHomeSurveyEffect();

  useHomeAppRateEffect();
  useHomeMembershipRefreshEffect();
  useHomePushNotificationsEffect();

  return (
    <HomeLayout>
      <HomeRefreshProvider
        extraRefreshFns={[refetchConfig, fetchAndOpenSurveyModal]}
        onBeforeRefresh={() => triggerEvent('pull_to_refresh')}>
        <HomePageContent>
          <Stack spacing={SizingMultiplier.sm} mt={SizingMultiplier.sm}>
            <WelcomeSectionController />
            <HowDoesItWorkCardController />
            <RewardsController />
            {config?.userExperience.offers.gridLocation === OffersGridLocation.Tab ? (
              <HomeOffersFeaturedStripController />
            ) : (
              <HomeOffersGridOnHomeController />
            )}
          </Stack>
          <ReferralStatusController key={membership.id} />
        </HomePageContent>
        <LoyaltyIdBarcodeController />
        <LoyaltyEventBackdropController />
        <HomeBottomNavigationController />
      </HomeRefreshProvider>
      <HomeRoutes />
    </HomeLayout>
  );
};
